import { useSearchParams } from 'react-router-dom';
import {
  PUBLIC_TEST_CATEGORIES,
  normalizeCategorySlug,
  type PublicTestCategory,
} from '../public-categories';

export function usePublicTestCategory(validCategories?: Array<{ id: string }>) {
  const [params, setParams] = useSearchParams();
  const paramCat = params.get('category');

  let selectedCategory = 'all';
  if (paramCat) {
    const normalized = normalizeCategorySlug(paramCat);
    if (validCategories && validCategories.length > 0) {
      const found = validCategories.find(
        (c) =>
          c.id.toLowerCase() === normalized ||
          c.id.toLowerCase() === paramCat.toLowerCase(),
      );
      selectedCategory = found ? found.id : 'all';
    } else {
      const found = PUBLIC_TEST_CATEGORIES.find(
        (c) =>
          c.id.toLowerCase() === normalized ||
          c.id.toLowerCase() === paramCat.toLowerCase(),
      );
      selectedCategory = found ? found.id : 'all';
    }
  }

  // A new category starts a fresh search: text meant for another category (or put in a
  // landing link) would only leave the new one empty. Level and price filters stay.
  const setSelectedCategory = (category: PublicTestCategory | string) => {
    setParams((previous) => {
      const next = new URLSearchParams(previous);
      next.delete('page');
      next.delete('search');
      next.delete('subject');
      if (!category || category === 'all') next.delete('category');
      else next.set('category', category);
      return next;
    });
  };

  return { selectedCategory, setSelectedCategory };
}
